import axios from 'axios';
import Lodash from 'lodash';
import { useQuery } from 'react-query';
import Consts from '../Consts/Consts';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

export const addNew = params => {
  const { nacionalEnca, tFrmsCandidatos } = params;

  const papeletaData = {
    nacionalEnca,
    tFrmsCandidatos,
  };

  return axios.post('/papeletaNacional', papeletaData);
};

export const getNumPapeletasNacionales = (
  idProvince,
  idMovimiento,
) => {
  const url = [
    `/papeletaNacional/numPapeletas/${idProvince}/${idMovimiento}`,
  ];

  return axios.get(url.join('&'));
};

export const getNumPapeletaStatus = params => {
  const { papeleta, provincia, movimiento } = params;
  const url = [
    `/papeletaNacional/numPapeletaStatus/${papeleta}/${provincia}/${movimiento}`,
  ];
  return axios.get(url.join('&'));
};

export const blockNumPapeleta = params => {
  const {
    numPapeleta,
    codProvincia,
    codMovimiento,
  } = params;

  const papeletaData = {
    numPapeleta,
    codProvincia,
    codMovimiento,
  };

  return axios.post(
    '/papeletaNacional/blockNumPapeleta',
    papeletaData,
  );
};

export const updatePapeleta = params => {
  const {
    codPapeleta,
    nacionalEnca,
    tFrmsCandidatos,
  } = params;

  const papeletaData = {
    codPapeleta,
    nacionalEnca,
    tFrmsCandidatos,
  };

  return axios.post(
    '/papeletaNacional/update',
    papeletaData,
  );
};

const getCandidatosPapeleta = async codPapeleta => {
  const url = [
    `/papeletaNacional/getCandidatosPapeleta/${codPapeleta}`,
  ];

  const { data } = await axios.get(url.join('&'));

  return data;
};

const searchByCedula = async cedula => {
  const url = [`/padron/searchbycedula/${cedula}`];
  const { data } = await axios.get(url.join('&'));
  return data;
};

const preparedList = list => {
  const unlockedList = list.map(e => {
    Lodash.set(e, 'enabled', false);
    return e;
  });
  return unlockedList;
};

const getAllDataPapeleta = async (data, codPapeleta) => {
  const initValues = Consts.nacionalesInitValues;
  Lodash.set(initValues, 'movimiento', data.ind_movimiento);
  Lodash.set(initValues, 'puesto', data.num_puesto);

  // Se preparan las listas para que los campos esten desbloquedos
  const iListComite = preparedList(
    Consts.initListComiteNacional,
  );

  // console.log(iListComite);

  // Se obtiene el numero de delegados
  let numCandidatos = 1;
  if (
    data.ind_movimiento === 3 ||
    data.ind_movimiento === 4
  ) {
    numCandidatos = 3;
  } else {
    numCandidatos = 1;
  }

  // Se obtienen todos los candidatos registrados en la papeleta
  const candidatos = await getCandidatosPapeleta(
    codPapeleta,
  );

  // console.log(candidatos);

  let sexFieldAs = '';
  let isSexOrderRequired = true;
  let onlyJuventud = false;

  if (data.ind_movimiento === 1) {
    sexFieldAs = 'F';
    isSexOrderRequired = false;
  }

  if (data.ind_movimiento === 2) {
    onlyJuventud = true;
  }

  /* ====== Lista de Comité ====== */

  const listComite = await Promise.all(
    candidatos.map(async (d, index) => {
      const miembro = await searchByCedula(d.NUM_CEDULA);

      // Datos de la persona
      const person = Lodash.get(miembro, ['response', 0]);

      // Nombre de la persona
      const personName = `${person.des_nombre} ${person.des_apell1} ${person.des_apell2}`;
      const personCedula = person.num_cedula;
      const personEdad = person.num_edad;
      let sexVal = 'M';
      if (person.sexo !== 1) {
        sexVal = 'F';
      }

      // Nombre del campo
      const field = Lodash.get(iListComite, [index]);

      Lodash.set(initValues, field.fieldName, personCedula);

      return {
        id: index + 1,
        lugar: field.lugar,
        numPuesto: d.NUM_PUESTO,
        fieldName: field.fieldName,
        cedula: personCedula,
        nombre: personName,
        sexo: sexVal,
        edad: personEdad,
        enabled: true,
        filled: true,
      };
    }),
  );

  // Merging List Comite
  const allComite = Lodash.merge(iListComite, listComite);
  const firstComite = allComite[0].sexo;
  let sexOrderComite = Consts.comiteNacionalMOrder;
  if (firstComite !== 'M') {
    sexOrderComite = Consts.comiteNacionalFOrder;
  }

  // Se establece el sexo para el resto de la lista
  const finalListComite = Lodash.map(
    allComite,
    (d, index) => {
      const newData = {
        id: d.id,
        lugar: d.lugar,
        numPuesto: d.numPuesto,
        fieldName: d.fieldName,
        cedula: d.cedula,
        nombre: d.nombre,
        sexo: isSexOrderRequired
          ? sexOrderComite[index].sexo
          : sexFieldAs,
        edad: d.edad,
        enabled: d.cedula !== '',
        filled: d.filled,
      };

      return newData;
    },
  );

  return {
    papeletaData: data,
    numCandidatos,
    candidatos: {
      listComite: finalListComite,
    },
    initValues,
    onlyJuventud,
    sexFieldAs,
    isSexOrderRequired,
  };
};

export const getPapeletaInfo = async params => {
  try {
    const { cedGestor, codPapeleta } = params;

    const url = [
      `/papeletaNacional/getByCodPapeleta/${cedGestor}/${codPapeleta}`,
    ];

    const { data } = await axios.get(url.join('&'));

    const papeletaData = getAllDataPapeleta(
      data.response[0],
      codPapeleta,
    );

    return papeletaData;
  } catch (e) {
    return { papeletaData: {} };
  }
};

export const usePapeletaInfo = (cedGestor, codPapeleta) => {
  return useQuery(
    ['papeletaData', cedGestor, codPapeleta],
    () => getPapeletaInfo(cedGestor, codPapeleta),
  );
};
